import React, { Component } from 'react'
import { get, isEmpty, pick } from 'lodash'
import { message } from 'antd'
import QuotesApi from '../../../api/Sales/Quotes'
import { dateFormat, dateVal, moneyInline, numVal, strVal } from '../../../modules/Utils'
import Email from '../../../api/Email'
import Templates from '../../../api/Templates'
import Quotes from '../../../components/Sales/Quotes/Quotes'

class QuotesCont extends Component {
  state = {
    list: [],
    emailDetails: {},
    selection: [],
    fetching: false,
  }
  api = new QuotesApi()
  emailApi = new Email()
  templateApi = new Templates()

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const cached = await this.api.list()
      let list = cached
      if (!isEmpty(this.state.company)) list = cached.filter((i) => i.company._id === this.state.company)
      this.setState({
        fetching: false,
        list,
        cached: list,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  filterCompany = (_id) => {
    this.setState((prevState, props) => ({
      list: _id ? prevState.cached.filter((i) => i.company._id === _id) : prevState.cached,
    }))
  }
  onChangeCompany = (company) => {
    this.filterCompany(company)
    this.setState({
      company,
    })
  }
  toggleSelection = (key) => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)]
    } else {
      selection.push(key)
    }
    this.setState({ selection })
  }
  isSelected = (key) => {
    return this.state.selection.includes(key)
  }
  tableRef = React.createRef()
  toggleAll = () => {
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      const wrappedInstance = this.tableRef.current.getWrappedInstance()
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach((item) => {
        selection.push(item._original._id)
      })
    }
    this.setState({ selectAll, selection })
  }
  invoiceBookings = async () => {
    try {
      this.setState({
        invoicing: true,
      })
      await this.api.invoice(this.state.selection)
      this.setState({
        invoicing: false,
        selection: [],
      })
      message.success('Invoiced')
    } catch (e) {
      this.setState({
        invoicing: false,
      })
      message.error(e.errorMessage)
    }
  }

  showEmail = async () => {
    const selection = this.state.selection.map((t) => this.state.list.find((i) => i._id === t))
    if (!selection.reduce((prv, current) => (get(prv, 'enquirer._id') === get(current, 'enquirer._id') ? prv : NaN))) {
      message.error('Not the same Enquirer')
      return
    }
    if (!selection.reduce((prv, current) => (get(prv, 'company._id') === get(current, 'company._id') ? prv : NaN))) {
      message.error('Not the same company')
      return
    }
    if (selection.find((s) => s.status !== 'Confirmed')) {
      message.error(`Can't email non confirmed Quotations`)
      return
    }
    try {
      this.setState({
        fetchingEmailTemplate: true,
      })
      const lines = selection.map((i) => ({
        date: dateFormat(dateVal(i, 'date')),
        no: i.revision ? strVal(i, 'code') + '.0' + strVal(i, 'revision') : strVal(i, 'code'),
        type: strVal(i, 'type'),
        amount: moneyInline(numVal(i, 'amount'), strVal(i, 'currency')),
        dueDate: dateFormat(dateVal(i, 'validity.date')),
      }))
      const quoteTemplate = await this.templateApi.read(
        strVal(selection, '0.company._id').replace('members/', ''),
        'quote'
      )
      const emailDetails = get(quoteTemplate, 'email') || {}
      const data = await this.emailApi.quoteTemplate({
        receiver: get(selection, '0.enquirerRep.fn'),
        company: get(selection, '0.company'),
        lines: lines,
        ...emailDetails,
      })
      const filesList = await this.api.files(selection.map((s) => s._id))
      const filesMapped = filesList.map((f) => f.uuid)
      this.setState({
        visibleEmail: true,
        emailTemplate: data.html,
        fetchingEmailTemplate: false,
        emailFiles: filesList,
        emailLines: selection,
        emailDetails: {
          to: get(selection, '0.enquirerRep.email.label'),
          cc: get(selection, '0.companyRep.email.label'),
          bcc: get(emailDetails, 'bcc'),
          from: get(emailDetails, 'from'),
          subject: get(emailDetails, 'subject'),
          attachments: filesMapped,
        },
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        fetchingEmailTemplate: false,
      })
    }
  }

  onCancelEmail = () => {
    this.setState({
      visibleEmail: false,
      emailDetails: {},
      selection: [],
    })
  }

  render() {
    return (
      <Quotes
        {...this.state}
        {...pick(this, [
          'fetch',
          'fetching',
          'filterCompany',
          'invoiceBookings',
          'onChangeCompany',
          'showEmail',
          'onCancelEmail',
          'toggleSelection',
          'isSelected',
          'toggleAll',
          'tableRef',
        ])}
      />
    )
  }
}

QuotesCont.propTypes = {}
QuotesCont.defaultProps = {}

export default QuotesCont
